import { Tabs } from "../profile/tabs";

type TabNavigationProps = {
  activeTab: number;
  setActiveTab: React.Dispatch<React.SetStateAction<number>>;
  texts: string[];
  className?: string;
  hideNavs?: (index: number) => boolean;
};

export const TabNavigation = ({
  activeTab,
  setActiveTab,
  texts,
  className = "flex flex-1 flex-row border-b border-gray-200",
  hideNavs,
}: TabNavigationProps) => {
  return (
    <div className={className}>
      {texts.map((text, index) => {
        if (hideNavs && hideNavs(index)) return null;
        return (
          <Tabs
            key={index}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            index={index}
            text={text}
          />
        );
      })}
    </div>
  );
};
